import React from 'react';
import { UsersIcon, ShieldCheckIcon, TrendingUpIcon, HandshakeIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface ValueItem {
  icon: React.ReactNode;
  title: string;
  line1: string;
  line2: string;
}
const VALUES: ValueItem[] = [{
  icon: <UsersIcon className="w-7 h-7 text-[#0A1F5C]" data-id="element-439" />,
  title: 'Make an Impact',
  line1: 'Your work matters.',
  line2: 'Every detail counts.'
}, {
  icon: <ShieldCheckIcon className="w-7 h-7 text-[#0A1F5C]" data-id="element-440" />,
  title: 'Own It',
  line1: 'Take pride in your work.',
  line2: 'Take ownership of results.'
}, {
  icon: <TrendingUpIcon className="w-7 h-7 text-[#0A1F5C]" data-id="element-441" />,
  title: 'Grow Together',
  line1: 'Grow your skills.',
  line2: 'Grow your career.'
}, {
  icon: <HandshakeIcon className="w-7 h-7 text-[#0A1F5C]" data-id="element-442" />,
  title: 'Team Is Everything',
  line1: 'Support each other.',
  line2: 'Succeed together.'
}];
export function ValuesFooter() {
  return <motion.footer initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.6,
    delay: 0.8
  }} className="pt-8" data-id="element-443">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-444">
        <div className="p-6 md:p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-445">
          {VALUES.map(v => <div key={v.title} className="flex items-start gap-3" data-id="element-446">
              <div className="shrink-0" data-id="element-447">{v.icon}</div>
              <div data-id="element-448">
                <h4 className="text-sm font-bold text-[#0A1F5C] uppercase tracking-wider mb-1" data-id="element-449">
                  {v.title}
                </h4>
                <p className="text-xs text-gray-600 leading-relaxed" data-id="element-450">
                  {v.line1}
                  <br data-id="element-451" />
                  {v.line2}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-[#0A1F5C] text-white py-6 px-6 text-center" data-id="element-452">
          <h2 className="text-lg md:text-xl font-black tracking-[0.2em] uppercase mb-2" data-id="element-453">
            Process Today. Lead Tomorrow.{' '}
            <span className="text-[#E8801F]" data-id="element-454">Build Your Future.</span>
          </h2>
          <p className="text-[10px] text-blue-200 font-medium uppercase tracking-wider" data-id="element-455">
            Compensation structures, requirements, and policies are subject to
            change at any time.
          </p>
        </div>
      </div>
    </motion.footer>;
}